import React from "react";
import UpdateTariffModal, {
  Benefits,
  MembershipCard,
  UpdateTariffModalProps,
} from "./UpdateTariffModal";
import { CircularProgress } from "@mui/material";
interface UpgradeModalProps extends Omit<UpdateTariffModalProps, "children"> {
  closeModal: () => void;
  upgrade: (membershipId: number) => void;
  pending?: boolean;
}

const UpgradeModal = ({
  isVisible,
  closeModal,
  upgrade,
  pending,
}: UpgradeModalProps) => {
  return (
    <UpdateTariffModal isVisible={isVisible}>
      <h2>Woohoo! You’re almost there.</h2>
      <h3>
        By upgrading to the Annual Membership, you will{" "}
        <span className="strong">gain free access to</span>
      </h3>
      <Benefits
        benefits={[
          { text: "Pre Baby Bootcamp", positive: true, price: "$399" },
          { text: "Mom Survival Group", positive: true, price: "$249" },
          {
            text: "Group Infant and Child CPR with First Aid",
            positive: true,
            price: "$100",
          },
          { text: "Group Sleep Consult", positive: true, price: "$99" },
        ]}
      />
      <MembershipCard
        title="Annual Membership"
        price="$83"
        priceOld="$149"
        priceSum="$999"
        priceSumDescription="annually, cancel any time."
        type="green"
      />
      <div className="updateTariffModalButtons">
        <button
          className="btn primary-blue-small-btn-40 updateTariffModalButtons__confirm"
          onClick={() => upgrade(2)}
        >
          {pending ? <CircularProgress size={16} /> : "Confirm Upgrade"}
        </button>
        <button
          className="btn primary-blue-small-btn-40 updateTariffModalButtons__close"
          onClick={closeModal}
        >
          Keep Monthly Membership
        </button>
      </div>
    </UpdateTariffModal>
  );
};

export default UpgradeModal;
